import {
  CONNECTOR_FAMILY_CODE_FLAT_FLIP,
  CONNECTOR_FAMILY_CODE_GAP,
  CONNECTOR_FAMILY_CODE_KKA_AISI410,
  CONNECTOR_FAMILY_CODE_KKA_COLOR,
  CONNECTOR_FAMILY_CODE_KKT_A4_AISI316,
  CONNECTOR_FAMILY_CODE_KKT_COLOR,
  CONNECTOR_FAMILY_CODE_SNAP,
  CONNECTOR_FAMILY_CODE_TERRALOCK,
  CONNECTOR_FAMILY_CODE_TERRALOCK_A2,
  CONNECTOR_FAMILY_CODE_TERRALOCK_PP,
  CONNECTOR_FAMILY_CODE_TVM,
} from "../../../http/deckDesigner/types/connectorFamilies";
import {
  SUPPORT_FAMILY_CODE_GRANULO,
  SUPPORT_FAMILY_CODE_JFA,
  SUPPORT_FAMILY_CODE_NAG,
  SUPPORT_FAMILY_CODE_SUP_L,
  SUPPORT_FAMILY_CODE_SUP_M,
  SUPPORT_FAMILY_CODE_SUP_S,
} from "../../../http/deckDesigner/types/supportFamilies";

// Not stored in the DB (SupportFamily has no image field) - local files under public/, added later.
export const SUPPORT_FAMILY_IMAGE_BY_CODE: Record<string, string> = {
  [SUPPORT_FAMILY_CODE_JFA]: "/deckDesigner/jfa.png",
  [SUPPORT_FAMILY_CODE_SUP_S]: "/deckDesigner/sup-s.png",
  [SUPPORT_FAMILY_CODE_SUP_M]: "/deckDesigner/sup-m.png",
  [SUPPORT_FAMILY_CODE_SUP_L]: "/deckDesigner/sup-l.png",
  [SUPPORT_FAMILY_CODE_NAG]: "/deckDesigner/nag.png",
  [SUPPORT_FAMILY_CODE_GRANULO]: "/deckDesigner/granulo.png",
};

// Not stored in the DB (ConnectorFamily has no image field) - local files under public/, added later.
export const CONNECTOR_FAMILY_IMAGE_BY_CODE: Record<string, string> = {
  [CONNECTOR_FAMILY_CODE_TVM]: "/deckDesigner/tvm.png",
  [CONNECTOR_FAMILY_CODE_FLAT_FLIP]: "/deckDesigner/flat-flip.png",
  [CONNECTOR_FAMILY_CODE_GAP]: "/deckDesigner/gap.png",
  [CONNECTOR_FAMILY_CODE_SNAP]: "/deckDesigner/snap.png",
  [CONNECTOR_FAMILY_CODE_TERRALOCK]: "/deckDesigner/terralock.png",
  // TODO: swap in the dedicated TERRALOCK A2 / TERRALOCK PP images once available - reusing the
  // plain TERRALOCK one as a placeholder since the physical connector shape is otherwise identical.
  [CONNECTOR_FAMILY_CODE_TERRALOCK_A2]: "/deckDesigner/terralock.png",
  [CONNECTOR_FAMILY_CODE_TERRALOCK_PP]: "/deckDesigner/terralock.png",
  [CONNECTOR_FAMILY_CODE_KKT_COLOR]: "/deckDesigner/kkt-color.png",
  [CONNECTOR_FAMILY_CODE_KKT_A4_AISI316]: "/deckDesigner/kkt-a4-aisi316.png",
  [CONNECTOR_FAMILY_CODE_KKA_COLOR]: "/deckDesigner/kka-color.png",
  [CONNECTOR_FAMILY_CODE_KKA_AISI410]: "/deckDesigner/kka-aisi410.png",
};
